import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { FCC } from "@/types";

import { WelcomeCard } from "./WelcomeCard";

interface Props {
  onBack: () => void;
}

export const MagicLinkEmailSent: FCC<Props> = ({ onBack }) => {
  const { t } = useTranslation();

  return (
    <WelcomeCard>
      <div
        className="flex w-full flex-col items-center gap-6"
        data-testid="magic-link-email-sent"
      >
        <p className="text-body-base text-foreground-primary">
          {t("translation:newWelcome.magicLink.sent.message")}
        </p>

        <Button
          variant="primary"
          type="button"
          onClick={onBack}
          dataTestid="magic-link-email-sent-back"
        >
          {t("translation:newWelcome.magicLink.sent.backButton")}
        </Button>
      </div>
    </WelcomeCard>
  );
};
